// 本地存储操作封装
const localCache = {
  // 缓存前缀，避免键名冲突
  prefix: '',

  // 获取缓存
  get: function (key) {
    try {
      const value = localStorage.getItem(this.prefix + key);
      if (value) {
        // 解析缓存数据，包含过期时间
        const parsed = JSON.parse(value);
        // 检查是否过期
        if (parsed.expiry && Date.now() > parsed.expiry) {
          this.remove(key);
          return null;
        }
        return parsed.data;
      }
      return null;
    } catch (error) {
      // todo: 处理本地存储空间异常的情况,暂无使用场景，预留功能
      console.error('读取本地缓存失败:', error);
      return null;
    }
  },

  // 设置缓存
  set: function (key, value, ttl = null) {
    try {
      const data = {
        data: value,
        // 设置过期时间，ttl为毫秒数
        expiry: ttl ? Date.now() + ttl : null
      };
      localStorage.setItem(this.prefix + key, JSON.stringify(data));
      return true;
    } catch (error) {
      // todo: 处理本地存储空间异常的情况,暂无使用场景，预留功能
      console.error('设置本地缓存失败:', error);
      return false;
    }
  },

  // 移除缓存
  remove: function (key) {
    try {
      localStorage.removeItem(this.prefix + key);
      return true;
    } catch (error) {
      // todo: 处理异常的情况,暂无使用场景，预留功能
      console.error('移除本地缓存失败:', error);
      return false;
    }
  },

  // 清除所有翻译相关缓存
  clearAll: function () {
    try {
      Object.keys(localStorage).forEach((key) => {
        if (key.startsWith(this.prefix)) {
          localStorage.removeItem(key);
        }
      });
      return true;
    } catch (error) {
      console.error('清除所有本地缓存失败:', error);
      return false;
    }
  }
};

export default localCache;



// WEBPACK FOOTER //
// ./src/utils/cache/localCache.js